module.exports = __webpack_public_path__ + "img/img13.1b2b65e9.svg";